module.exports = __webpack_public_path__ + "static/media/pinterest_logo.9c4afcdb.svg";